const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.info,
}

export default getters
